import React from 'react';

interface DoubleChevronIconProps {
  rotated?: boolean;
}

const DoubleChevronIcon: React.FC<DoubleChevronIconProps> = ({ rotated }) => (
  <svg
    width="34"
    height="30"
    viewBox="0 0 34 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: rotated ? 'rotate(180deg)' : 'none',
      transition: 'transform 0.3s ease',
      display: 'block'
    }}
  >
    <path d="M29.7531 14.75L17.0031 22.25L4.25313 14.75L1.70312 16.25L17.0031 25.25L32.3031 16.25L29.7531 14.75Z" fill="black" fillOpacity="0.33"/>
    <path d="M29.7531 4.75L17.0031 12.25L4.25313 4.75L1.70312 6.25L17.0031 15.25L32.3031 6.25L29.7531 4.75Z" fill="black" fillOpacity="0.33"/>
  </svg>
);

export default DoubleChevronIcon; 